import {
  PatchApiSpoSportSettingsBody,
  PostApiSpoSportsBody,
  SpoPatchSportSettingsResponse,
  SpoSportsResponse,
} from '@spo/types';
import { apiBff } from '.';

export const getSports = async (
  postApiSpoSportsBody: PostApiSpoSportsBody,
): Promise<SpoSportsResponse> => {
  return apiBff.callBFF('POST', 'spo/sports', postApiSpoSportsBody);
};

export const patchSportSettings = async ({
  sportId,
  genderIds,
  segmentationId,
  language,
}: PatchApiSpoSportSettingsBody): Promise<SpoPatchSportSettingsResponse> => {
  return apiBff.callBFF('PATCH', 'spo/sport/settings', {
    sportId,
    genderIds,
    segmentationId,
    language,
  });
};
